import styled from 'styled-components';
import { COLOR_BLACK } from '../../../../assets/styles/colors';

export default styled.div`
  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
    p {
      width: 100%;
      text-align: left;
      padding-top: 16px;
    }
  }
  .answers-wrap {
    padding-top: 20px;
    ul {
      color: ${COLOR_BLACK};
      padding-left: 20px;
      margin-bottom: 0px;
      li {
        color: ${COLOR_BLACK};
        font-size: 16px;
      }
    }
  }
  .submit-wrap {
    margin-top: 48px;
    button {
      width: 100%;
      &:last-child {
        margin-top: 10px;
      }
    }
  }
`;
